{
  "version": 1,
  "asset_id": "c2a5e7d8-a5ac-4200-8d08-c2229ac029dd",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/c2a5e7d8-a5ac-4200-8d08-c2229ac029dd/autohaulerexchange-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/c2a5e7d8-a5ac-4200-8d08-c2229ac029dd/autohaulerexchange-240.webp",
  "original_filename": "autohaulerexchange-240.webp",
  "size": 6922,
  "content_type": "image/webp",
  "created_at": "2026-09-21T21:10:16Z"
}
